import { render } from "./WorkshopPage.vue?vue&type=template&id=c8444a34"
import script from "./WorkshopPage.vue?vue&type=script&lang=js"
export * from "./WorkshopPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__